/**
 * Servicios de los catálogos del ERP (F1, B1): marcas, fabricantes, atributos, unidades de medida,
 * productos, monedas y tipo de cambio.
 */

import api from './api.js';

const limpio = (params = {}) => {
  const out = {};
  Object.keys(params).forEach((k) => {
    if (params[k] !== '' && params[k] !== null && params[k] !== undefined) out[k] = params[k];
  });
  return out;
};

function crud(base) {
  return {
    listar: (params) => api.get(base, limpio(params)),
    obtener: (id) => api.get(`${base}/${id}`),
    crear: (data) => api.post(base, data),
    actualizar: (id, data) => api.put(`${base}/${id}`, data),
    eliminar: (id) => api.delete(`${base}/${id}`),
    restaurar: (id) => api.post(`${base}/${id}/restaurar`)
  };
}

export default {
  marcas: crud('/marcas'),
  fabricantes: crud('/fabricantes'),
  atributos: crud('/atributos'),
  unidadesMedida: crud('/unidades-medida'),
  productos: crud('/productos'),
  monedas: { listar: () => api.get('/monedas') },
  tiposCambio: {
    resumen: () => api.get('/tipos-cambio/resumen'),
    vigente: (moneda, fecha) => api.get('/tipos-cambio/vigente', limpio({ moneda, fecha })),
    listar: (params) => api.get('/tipos-cambio', limpio(params)),
    capturar: (data) => api.post('/tipos-cambio', data),
    anular: (id) => api.delete(`/tipos-cambio/${id}`),
    descargar: (data = {}) => api.post('/tipos-cambio/descargar', data)
  }
};
